class MapBox {
  constructor() {
    this.mapContainer = document.querySelector('.contact-map__mapbox')
    if (this.mapContainer) {
      this.map;
      this.markers = []
      this.coordinates = new mapboxgl.LngLatBounds();
      this.init()
    }
  }

  init() {
    mapboxgl.accessToken = "pk.eyJ1IjoicjhlZGdlIiwiYSI6ImNsdmdhMGl3czBxa2gyam80MnRwMDU0bmEifQ.nhHJZ8thSAT8qbeiJv4UcQ";
    this.map = new mapboxgl.Map({
      container: "contact-map-mapbox", // container ID
      style: "mapbox://styles/r8edge/clvgbmj9w00sx01o0date7be2", // Custom
    });

    let marker
    document.querySelectorAll('.contact-map__office').forEach((address) => {
      const color = '#01796E';
      marker = new mapboxgl.Marker({ color: color }).setLngLat([address.dataset.longitude, address.dataset.latitude]).addTo(this.map)
      const popup = new mapboxgl.Popup({ offset: 25, maxWidth: "23rem" })
        .setLngLat([address.dataset.longitude, address.dataset.latitude])
        .addTo(this.map)
      if (address.children.length > 0) {
        popup.setHTML(address.innerHTML)
      }
      marker.setPopup(popup)

      const element = marker.getElement();
      // element
      element.setAttribute('data-slug', address.getAttribute('data-slug'))
      element.setAttribute('data-longitude', address.dataset.longitude)
      element.setAttribute('data-latitude', address.dataset.latitude)
      element.addEventListener('click', () => {
        popup.addTo(this.map)
      });
      marker.setPopup(popup);
      marker.addTo(this.map);
      this.coordinates.extend([address.dataset.longitude, address.dataset.latitude]);
      this.map.fitBounds(this.coordinates, {
        padding: 50,
        linear: false,
        speed: 2,
      });
      this.markers.push(marker)
      popup.on('close', (ev) => {
        const alreadyOpen = document.querySelector('.contact-map__list .active')
        if (alreadyOpen) {
          alreadyOpen.classList.remove('active')
        }
        if (alreadyOpen == ev.target) return
        // find slug
        const slug = ev.target._marker._element.dataset.slug
        const target = document.querySelector(`.contact-map__list [data-target="${slug}"]`)
        target.classList.add('active')
      })
      popup.on('open', (ev) => {
        const alreadyOpen = document.querySelector('.contact-map__list .active')
        if (alreadyOpen) {
          alreadyOpen.classList.remove('active')
        }
        if (alreadyOpen == ev.target) return
        // find slug
        const slug = ev.target._marker._element.dataset.slug
        const target = document.querySelector(`.contact-map__list [data-target="${slug}"]`)
        target.classList.add('active')
      })
    })

    this.mapContainer.addEventListener('click', (ev) => {
      if (ev.target.classList.contains('mapboxgl-popup-close-button')) {
        const alreadyOpen = document.querySelector('.contact-map__list .active')
        if (alreadyOpen) {
          alreadyOpen.classList.remove('active')
        }
      }
    })

    // Add click on nav-list
    const list = document.querySelector('.contact-map__list')
    list.addEventListener('click', (ev) => {
      if (ev.target.hasAttribute('data-target')) {
        let marker_target = ev.target.dataset.target
        // Look for already active elements
        const alreadyOpen = document.querySelector('.contact-map__list .active')
        if (alreadyOpen) {
          alreadyOpen.classList.remove('active')
        }
        if (alreadyOpen != ev.target) {
          ev.target.classList.add('active')
        }

        // Find marker
        let marker = this.markers.find(el => el._element.getAttribute('data-slug') == marker_target)

        // Close any open markers
        this.markers.forEach(marker => {
          const popup = marker.getPopup()
          if (popup.isOpen()) {
            marker.togglePopup()
          } else {
            marker.addTo(this.map)
          }
        })
        if (window.innerWidth < 768) {
          this.mapContainer.querySelector('.mapboxgl-map').scrollIntoView()
        }
        marker.togglePopup()
      }
    })
  }

}

export default MapBox;